import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteInfo';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-circle-fill text-background-50 text-xl" style={{ lineHeight: 1 }}></i>
              </div>
              <span className="text-lg font-bold font-heading text-background-50 whitespace-nowrap">91视频</span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed mb-4">{siteInfo.tagline}</p>
            <div className="flex items-center gap-3">
              <a href={siteInfo.socialLinks.weibo} rel="nofollow" className="w-8 h-8 rounded-lg bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-lg bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href={siteInfo.socialLinks.qq} rel="nofollow" className="w-8 h-8 rounded-lg bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">视频分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-background-300 hover:text-primary-400 transition-colors">{cat.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">快捷链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors">网站首页</Link></li>
              <li><Link to="/category/dianying" className="text-sm text-background-300 hover:text-primary-400 transition-colors">热门电影</Link></li>
              <li><Link to="/category/dianshiju" className="text-sm text-background-300 hover:text-primary-400 transition-colors">热播剧集</Link></li>
              <li><Link to="/category/zongyi" className="text-sm text-background-300 hover:text-primary-400 transition-colors">综艺节目</Link></li>
              <li><Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">联系我们</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-background-400 text-sm mt-0.5"></i>
                <span className="text-sm text-background-300">{siteInfo.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-background-400 text-sm mt-0.5"></i>
                <span className="text-sm text-background-300">{siteInfo.phone}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-background-400 text-sm mt-0.5"></i>
                <span className="text-sm text-background-300">{siteInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="w-full px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 | 京ICP备2024XXXXXXXX号
          </p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="text-xs text-background-400 hover:text-background-200 transition-colors">关于我们</Link>
            <span className="text-xs text-background-400">|</span>
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors">隐私政策</a>
            <span className="text-xs text-background-400">|</span>
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}